import {DefaultLinkModel} from 'storm-react-diagrams';

class FlowDiagramLinkModel extends DefaultLinkModel {
    constructor() {
        super('advanced');
    }
}

export default FlowDiagramLinkModel;